import type { SequenceDefinition } from '.'

export function isPrime(num: number): boolean {
  if (num <= 1) {
    return false
  }
  if (num <= 3) {
    return true
  }
  if (num % 2 === 0 || num % 3 === 0) {
    return false
  }

  for (let i = 5; i * i <= num; i += 6) {
    if (num % i === 0 || num % (i + 2) === 0) {
      return false
    }
  }
  return true
}

export const primeSequence: SequenceDefinition<'prime'> = {
  'primeSeq': length => {
    const primes = []
    let num = 2
    while (primes.length < length) {
      if (isPrime(num)) {
        primes.push(num)
      }
      num += 1
    }
    return primes
  },
  'isPrime': n => isPrime(n),
}
